import Immutable from 'immutable';
import { combineReducers } from 'redux-immutablejs';

import commentsTransactions from './CommentsTransactionsReducer';
import quotationsTransactions from './QuotationsTransactionsReducer';
import ratingsTransactions from './RatingsTransactionsReducer';
import tagsTransactions from './TagsTransactionsReducer';
import videosTransactions from './VideosTransactionsReducer';
import iOwnThisTransactions from './IOwnThisTransactionsReducer';
import similarTitlesTransactions from './SimilarTitlesTransactionsReducer';
import privateNotesTransactionsReducer from './PrivateNotesTransactionsReducer';

export default combineReducers(Immutable.Map({
  commentsTransactions,
  quotationsTransactions,
  ratingsTransactions,
  tagsTransactions,
  videosTransactions,
  iOwnThisTransactions,
  similarTitlesTransactions,
  privateNotesTransactionsReducer
}));



// WEBPACK FOOTER //
// ./app/reducers/ugc/index.js